import { styled } from '@vebox/etui-system';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from './_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Svg as Svg$1 } from '@vebox/etui-system-elements';

const _excluded = ["size", "rotate"];
const SvgDiv = styled(Div).attrs(_ref => {
  let {
      size,
      rotate
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    display: 'inline-block',
    lineHeight: 0,
    fontSize: 0,
    width: size ? `${size}px` : '32px',
    height: size ? `${size}px` : '32px',
    flex: `0 0 ${size ? `${size}px` : '32px'}`,
    position: 'relative',
    transform: `rotate(${rotate}deg)`
  }, rest);
})`
  transition: 0.2s;
`;

const Svg = styled(Svg$1).attrs(props => _objectSpread2({
  width: '100%',
  fill: 'currentColor',
  stroke: 'currentColor',
  maxWidth: '100%',
  maxHeight: '100%',
  color: 'inherit',
  overflow: 'visible'
}, props))``;

export { SvgDiv as S, Svg as a };
